export default function Services() {
  const services = [
    {
      title: '남도음식 치유체험',
      description: '전통 남도음식을 직접 만들고 맛보며 몸과 마음을 치유하는 프로그램',
      features: ['전통 발효음식 체험', '약선요리 만들기', '건강한 식재료 교육'],
      icon: 'ri-restaurant-2-line',
      color: 'bg-orange-500'
    },
    {
      title: '유자농장 체험',
      description: '고흥 특산 유자를 활용한 다양한 치유 활동과 제품 만들기',
      features: ['유자 수확 체험', '유자차 만들기', '유자 아로마 테라피'],
      icon: 'ri-plant-line',
      color: 'bg-yellow-500'
    },
    {
      title: '숲 치유 프로그램',
      description: '자연 속에서 오감을 깨우고 스트레스를 해소하는 숲 치유',
      features: ['숲속 명상', '자연물 공예', '생태 관찰 활동'],
      icon: 'ri-tree-line',
      color: 'bg-green-500'
    },
    {
      title: '라벤더 아로마 테라피',
      description: '라벤더의 향기와 함께하는 마음의 평안을 찾는 시간',
      features: ['라벤더 수확', '에센셜 오일 만들기', '아로마 마사지'],
      icon: 'ri-flower-line',
      color: 'bg-purple-500'
    },
    {
      title: '커피농장 투어',
      description: '직접 재배한 커피로 만드는 특별한 커피 체험',
      features: ['커피 재배 견학', '로스팅 체험', '핸드드립 교육'],
      icon: 'ri-cup-line',
      color: 'bg-amber-600'
    },
    {
      title: '한옥펜션 힐링',
      description: '전통 한옥에서 느끼는 고즈넉한 휴식과 명상',
      features: ['한옥 숙박', '전통 차 체험', '마당에서 요가'],
      icon: 'ri-home-heart-line',
      color: 'bg-red-500'
    },
    {
      title: '원예 치유 프로그램',
      description: '다양한 꽃과 식물을 통한 마음의 치유와 성장',
      features: ['꽃 심기 체험', '정원 가꾸기', '플라워 아트'],
      icon: 'ri-seedling-line',
      color: 'bg-pink-500'
    },
    {
      title: '통합 치유 패키지',
      description: '여러 농가의 프로그램을 조합한 맞춤형 치유 여행',
      features: ['개인 맞춤 프로그램', '1박 2일 패키지', '장기 치유 과정'],
      icon: 'ri-heart-pulse-line',
      color: 'bg-blue-500'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-800 mb-6">치유 프로그램</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            자연과 농업의 힘을 활용한 다양한 치유 프로그램으로 몸과 마음의 건강을 회복하세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className={`w-16 h-16 ${service.color} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              
              <h4 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h4>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => document.getElementById('reservation')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            프로그램 예약하기
          </button>
        </div>
      </div>
    </section>
  );
}